import { render, staticRenderFns } from "./UserControls.vue?vue&type=template&id=d6af1a9e"
import script from "./UserControls.vue?vue&type=script&lang=js"
export * from "./UserControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports